export default {
  data(){
    return {
      skipTextSendWarningModalCookieName : 'skipWarningModal'
    };
  },

  methods : {
    shouldSkipWarningModal(){
      if( this.$cookies.get(this.skipTextSendWarningModalCookieName) === null ){
        return false;
      }else{
        return true;
      }
    },

    setSkipWarningModalCookie(shoudSetSkipCookie){
      if(shoudSetSkipCookie === false) return;

      this.$cookies.set(this.skipTextSendWarningModalCookieName, 'yes', '7d');
    }
  }
}